exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rounded-image.scaled[data-v-415f0ade] {\n  transform: scale(1);\n  transform: scale(1);\n  transition: 0.7s ease all;\n  -webkit-transition: 0.7s ease all;\n  -moz-transition: 0.7s ease all;\n}\n.rounded-image.scaled[data-v-415f0ade]:hover {\n  transform: scale(1.2);\n  -moz-transform: scale(1.2);\n  -webkit-transform: scale(1.2);\n}", ""]);

// exports
